<div class="auth">
  <aside class="hero">
    <img class="hero__img" src="assets/img/login-hero.jpg" alt="Tu marca, en cada sello. Tarjetas de lealtad tan bonitas como las impresas." />
  </aside>

  <main class="side">
    <app-brand class="side__brand" />
    <div class="side__form">
      <router-outlet />
    </div>
    <footer class="legal">
      © {{ year }} CradleRewards ·
      <a href="/legal/privacy" (click)="legal('privacy', $event)">Privacidad</a> ·
      <a href="/legal/terms" (click)="legal('terms', $event)">Términos</a>
    </footer>
  </main>
</div>
